import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const AppStoresLinksListContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 1rem;

  .link-branded {
    padding: 13px 18px;
  }

  @media screen and (max-width: ${layout.md}) {
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: fit-content;
    row-gap: 1rem;
  }
`;
